import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setOverlayPublisherVisible } from './actions.js';
import OverlayGeneric from '../../components/Overlay/OverlayGeneric';
import PublisherLogo from '../../components/Widget/PublisherLogo';
import PublisherDescription from '../../components/Overlay/CustomDescription';

const Overlay = props => (
    <OverlayGeneric
        isPartnerOrPublisherOverlay={true}
        logoComponent={PublisherLogo}
        aboutUsComponent={PublisherDescription}
        aboutUsContent={{
            description: props.publisherDescription,
            logoUrl: props.publisherLogoUrl
        }}
        isVisible={props.isVisible}
        isMobileResolution={props.isMobileResolution}
        setOverlayVisible={props.setOverlayPublisherVisible}
        transitionType={'right-to-left'}
        title={props.publisherName}
    />
);

Overlay.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    isMobileResolution: PropTypes.bool.isRequired,
    setOverlayPublisherVisible: PropTypes.func.isRequired,
    publisherName: PropTypes.string.isRequired,
    publisherLogoUrl: PropTypes.string.isRequired,
    publisherDescription: PropTypes.string.isRequired
};

export default connect(
    state => {
        return {
            isVisible: state.widget.isOverlayPublisherVisible,
            isMobileResolution: state.widget.isMobileResolution,
            publisherName: state.widget.publisherName,
            publisherDescription: state.widget.publisherDescription || '',
            publisherLogoUrl: state.widget.publisherLogoUrl || ''
        };
    },
    { setOverlayPublisherVisible }
)(Overlay);



// WEBPACK FOOTER //
// ./src/containers/Widget/OverlayPublisher.jsx